// TODO: Create a snapshot test to validate the ouput of different scenarios
import { useMemo } from 'react';
import { useUser } from '..';
function toRenderItem(item) {
    // children is intentionally omitted.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, itemContent, additionalProps, ...linkProps } = item;
    return {
        itemContent,
        linkProps,
        additionalProps: additionalProps ?? {},
    };
}
function renderItems(navigationItems, renderSubMenuItem, renderMenuItem, renderCategory, level = 0) {
    const mergedNavItems = [];
    for (const navItem of navigationItems) {
        const existingNavItem = mergedNavItems.find(x => x.itemContent === navItem.itemContent);
        if (!existingNavItem) {
            mergedNavItems.push(navItem);
        }
        else if (navItem.children) {
            existingNavItem.children = existingNavItem.children?.concat(navItem.children) ?? navItem.children;
        }
    }
    return mergedNavItems.map((navItem, navItemIndex) => {
        return renderCategory(navItem, navItem.children
            ? renderMenuItems(navItem.children.filter(navigationItem => navigationItem.isVisible || navigationItem.isVisible == null), renderSubMenuItem, renderMenuItem, level + 1) // increment level
            : null, navItemIndex, level);
    });
}
function renderMenuItems(navigationItems, renderSubMenuItem, renderMenuItem, level = 0) {
    return navigationItems.map((navItem, navItemIndex) => {
        return navItem.children
            ? renderMenuItem(navItem, renderSubMenuItems(navItem.children.filter(navigationItem => navigationItem.isVisible || navigationItem.isVisible == null), renderSubMenuItem, level + 1), // increment level
            navItemIndex, level)
            : renderSubMenuItems([navItem], renderSubMenuItem, level);
    });
}
function renderSubMenuItems(navigationItems, renderSubMenuItem, level = 0) {
    return navigationItems
        .filter(navigationItem => navigationItem.isVisible || navigationItem.isVisible == null)
        .map((navItem, navItemIndex) => {
        return renderSubMenuItem(toRenderItem(navItem), navItemIndex, level);
    });
}
export function useRenderedNavigationItems(navigationItems, renderSubMenuItem, renderSideBarMenuItem, renderSideBarCategory) {
    const user = useUser();
    return useMemo(() => {
        // Highest priority is rendered first.
        const sortedItems = [
            ...navigationItems.filter(navigationItem => {
                if (typeof navigationItem.isVisible === 'function') {
                    return navigationItem.isVisible(user.isSGICanadaUser);
                }
                if (typeof navigationItem.isVisible === 'boolean') {
                    return navigationItem.isVisible || navigationItem.isVisible == null;
                }
                return navigationItem.isVisible || navigationItem.isVisible == null;
            }),
        ]
            .sort((x, y) => {
            if (x.priority === y.priority) {
                return 0;
            }
            if (!x.priority && y.priority) {
                return -1;
            }
            if (x.priority && !y.priority) {
                return 1;
            }
            return x.priority <= y.priority ? -1 : 1;
        })
            // priority is intentionally omitted.
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(({ priority, ...itemProps }) => ({
            ...itemProps,
        }));
        return renderItems(sortedItems, renderSubMenuItem, renderSideBarMenuItem, renderSideBarCategory, 0);
    }, [navigationItems, renderSubMenuItem, renderSideBarMenuItem, renderSideBarCategory]);
}
